

















import Vue from 'vue';

import { formatDate } from '@/utils/vue_filters';

export default Vue.extend({
  name: 'EndDateCellPresenter',
  filters: {
    formatDate,
  },
});
